import forge from "node-forge";

const PUBLIC_KEY = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA9GRI2f3SjLqwgXgT15dW5z/WMLO86W/PBsJfTkmox162waKiobiKdncB6uBnYKZ0wg+qLEc/Wg1J7azM5woo3JTuFHpZ+VwRbr4VSNHSGi6aYKz/ySnA5ZJfbn9OJ8sEcCf3JNZVlJpAlRYZw224XVGI0HmAJN8GRRup4bJ2dfBraDg4wyKursDU8NVd3EG+4DqyR7ujySP2n1p08t2TCLKRWXxgF/vdqsUhKg0fhvZUThVOxrOP8MOZOYPW1T1L0qfBZJ98meoYqELR0QFXHQm16r3guvHS3Gb7tIoEW1OIt1lhhukvHjtkoosIczWiLXccf9dnG2lhJXPAfm7M8wIDAQAB";

function formatPublicKey(publicKey) {
    const content = (publicKey || "").replace(/\s+/g, "");
    const lines = content.match(/.{1,64}/g) || [];
    return `-----BEGIN PUBLIC KEY-----\n${lines.join("\n")}\n-----END PUBLIC KEY-----`;
}

function toUrlSafeBase64(binary) {
    return forge.util.encode64(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}

function encryptByKeySize(plainText, publicKey = PUBLIC_KEY) {
    const pem = formatPublicKey(publicKey);
    const key = forge.pki.publicKeyFromPem(pem);
    const buffer = forge.util.createBuffer(forge.util.encodeUtf8(plainText));
    const keyByteLength = Math.ceil(key.n.bitLength() / 8);
    const maxEncryptBlock = keyByteLength - 11;
    let encryptedBinary = "";

    while (buffer.length() > 0) {
        const chunk = buffer.getBytes(Math.min(maxEncryptBlock, buffer.length()));
        encryptedBinary += key.encrypt(chunk, "RSAES-PKCS1-V1_5");
    }

    return toUrlSafeBase64(encryptedBinary);
}

export {
    PUBLIC_KEY,
    encryptByKeySize,
};
